<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-primary print:hidden"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex h-20 items-center justify-center gap-2">
            <img class="w-8" src="images/logo/icon.png" alt="Logo image" />
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <div class="flex items-center space-x-2 pr-2">
            <!-- Navigation toggle button -->
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button -->
            <button
                class="hidden md:inline-flex"
                mat-icon-button
                (click)="toggleNavigationAppearance()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:arrows-right-left'"
                ></mat-icon>
            </button>
        </div>

        <div
            class="absolute left-1/2 -translate-x-1/2 transform"
            *ngIf="isValidAppUser"
        >
            <div
                class="text-base font-normal tracking-tight text-gray-900 dark:text-gray-100 sm:text-xl"
            >
                {{ user?.activeBranch?.branchName }}
            </div>
        </div>

        <div
            class="absolute left-1/2 -translate-x-1/2 transform"
            *ngIf="isInternalUser"
        >
            <div
                class="text-base font-normal tracking-tight text-gray-900 dark:text-gray-100 sm:text-xl"
            >
                EFRISBuddy Admin Console
            </div>
        </div>

        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <!--<languages></languages>-->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!--<search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>-->
            <messages *ngIf="isValidAppUser"></messages>
            <!--<notifications></notifications>
            <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                ></mat-icon>
            </button>-->
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <div
        class="bg-card relative z-49 flex min-h-14 w-full flex-0 flex-col justify-center gap-0.5 border-t px-4 py-2 dark:bg-transparent md:px-6 print:hidden"
    >
        <span class="text-secondary text-center text-sm"
            >For support please call Batte at: 256708379861 or Ahmad at:
            256701222383 | <strong>EFRISBuddy</strong> is a product of AJ
            CONSULTS LTD</span
        >
        <span class="text-secondary text-center text-xs"
            >Version v{{ buildInfo.version }} | Release r{{
                buildInfo.release
            }}
            | Commit {{ buildInfo.commit }} | Built
            {{ buildInfo.builtAt }}</span
        >
    </div>
</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
